export enum RouteEditMode {
  DESIGN = 'design',
  ALTERATIONS = 'alterations',
  RESTRICTIONS = 'restrictions'
}
